import { equalString } from '@/util/strings.ts'

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || 'https://api.clomental.com'
export const DISABLE_ALERTS_LIVE_FETCHING = equalString(import.meta.env.VITE_DISABLE_EMERGENCY_LIVE_FETCHING, 'true') || false
export const GOOGLE_MAPS_API_KEY = 'AIzaSyB5i1DXHPC5jnwz4EH0VKIYVBttVYqdQd8'; // Google Maps API Key 추가